__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-accounts/v3_1_1/";